var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-5"},[_c('crud-data-table',{attrs:{"service":_vm.customService,"headers":_vm.headers,"noActions":"","noAutoWidth":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }